// client.js
// Дизайн-система проекта: база martyrs (слои) + JIT-утилиты + тема Commune.
// Всё внутри @/design-system/index.js — единая точка подключения.
// Анимации (animations.scss) инлайнит тема — design-system/theme.scss.
import '@/design-system/index.js';

import { createUniversalApp } from '@ozdao/martyrs/modules/core/client';
import { moduleManager } from '@ozdao/martyrs/src/modules/core/views/classes/module.manager.js';

import { getConfig } from '@/configs/global.config.js';
import { getRouter } from '@/router/index.js';
import { getLocales } from '@/localization/index.js';

import { initScrollAnimations } from '@/design-system/animations/scrollAnimations.js';
import initGlobalAnimations from '@/design-system/animations/globals.js';
import { mixins } from '@ozdao/martyrs/modules/core/client';

// Создаем приложение используя фабрику
const appPromise = createUniversalApp({
  getConfig,
  getRouter,
  getLocales,
  getHooks: {
    beforeInitialize: () => performance.mark('init-start'),
    // Сессия — инфраструктура приложения, а не вклад маршрута: её читают гард
    // роутера, шапка и бэкофис. Модуль auth активируется до навигации и до
    // первого рендера, с контекстом запроса. Без этого стор auth не попадает в
    // data-state, и клиент на гидратации считает сессию отсутствующей
    // (тот же механизм в beautify.plus).
    afterInitialize: async (context) => {
      await moduleManager.activate('auth', context);
      performance.mark('init-end');
    },
    beforeHydration: () => performance.mark('hydration-start'),
    afterHydration: ({ router, store }) => {
      performance.mark('hydration-end');
      // Инициализируем анимации после гидратации
      initScrollAnimations();
      initGlobalAnimations();

      // PWA: редирект админа в бекофис при запуске с домашнего экрана
      const isPWA = window.matchMedia('(display-mode: standalone)').matches
        || window.matchMedia('(display-mode: minimal-ui)').matches
        || window.navigator.standalone === true;

      if (isPWA) {
        const auth = store.auth;
        if (auth?.state?.access?.status && auth.state.access.roles?.includes('ROLE_ADMIN')) {
          const currentPath = router.currentRoute.value.path;
          if (!currentPath.startsWith('/backoffice') && !currentPath.startsWith('/admin')) {
            router.replace('/backoffice');
          }
        }
      }
    }
  }
});

export async function _renderApp({ url, cookies, languages, ssrContext }) {
  const { renderApp } = await appPromise;

  return renderApp({ url, cookies, languages, ssrContext });
}
